import TrajectoryModal from './TrajectoryModal';

export default TrajectoryModal;
